import { render } from "./CreateUserPopup.vue?vue&type=template&id=772e4d78"
import script from "./CreateUserPopup.vue?vue&type=script&lang=js"
export * from "./CreateUserPopup.vue?vue&type=script&lang=js"

import "./CreateUserPopup.vue?vue&type=style&index=0&id=772e4d78&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__